import { useTranslation } from "react-i18next";

const VerifiedBadge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    style={{ marginLeft: 4 }}
  >
    <path
      d="M7.07143 0L5.78571 1.20202L3.78571 0.777778L3 2.54545L1.28571 2.9697L1.5 4.87879L0 6.22222L1.07143 7.70707L0.5 9.40404L2.14286 10.4646L2.35714 12.303H4.42857L5.71429 14L7.07143 12.8687L8.78572 13.8586L9.78572 12.303H11.7143L12 10.4646L13.6429 9.40404L13 7.70707L14 6.22222L12.6429 4.87879L12.7857 2.9697L11.2143 2.54545L10.2857 0.777778L8.42857 1.20202L7.07143 0Z"
      fill="#256ED3"
    />
    <path
      d="M4.643 6.85706L3.92871 7.7142L6.35728 9.92849L10.4287 4.99992L9.50014 4.2142L6.143 8.2142L4.643 6.85706Z"
      fill="white"
    />
  </svg>
);

const ReplyIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 17 4 12 9 7" />
    <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
  </svg>
);

// Nama brand & nama peserta organisasi berdasarkan phone_number_id grup admin.
const BRAND_BY_PHONE = {
  1: { header: "Kledo", org: "PT Kledo Berhati Nyaman" },
  2: { header: "GajiHub", org: "PT GajiHub Berhati Nyaman" },
  5: { header: "CRM.ID", org: "PT CRM Berhati Nyaman" },
};

/**
 * Pratinjau (read-only) pesan WhatsApp yang otomatis dikirim ke pelanggan saat
 * jadwal meeting dibuat. Data diisi live dari form Step 4 (Detail).
 */
const MeetingWhatsappPreview = ({
  name,
  salutation,
  company,
  dateLabel,
  startTime,
  endTime,
  phoneNumberId,
}) => {
  const { t } = useTranslation();
  const displayName =
    [salutation, name].filter(Boolean).join(" ") || "Pelanggan";
  const safeCompany = company || "-";
  const brand = BRAND_BY_PHONE[Number(phoneNumberId)] || BRAND_BY_PHONE[1];

  return (
    <div>
      <p className="mb-0 text-sm font-semibold text-neutral-800">
        {t("meeting_schedule.wa_preview_title")}
      </p>
      <p className="mb-3 text-xs text-neutral-500">
        {t("meeting_schedule.wa_preview_desc")}
      </p>

      <div className="overflow-hidden rounded-2xl border border-neutral-200 shadow-sm">
        {/* Header */}
        <div className="flex items-center gap-2 border-b border-neutral-200 bg-[#f0f2f5] px-3 py-2">
          <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-white ring-1 ring-neutral-200">
            <img
              src="/resources/images/logo-color-kledo-front.png"
              alt={brand.header}
              width={22}
            />
          </span>
          <div className="flex min-w-0 flex-col">
            <span className="flex items-center text-sm font-semibold text-neutral-900">
              {brand.header}
              <VerifiedBadge />
            </span>
            <span className="text-[11px] text-neutral-500">
              Official Business Account
            </span>
          </div>
        </div>

        {/* Body / chat */}
        <div className="bg-[#efeae2] p-3">
          <div className="rounded-lg rounded-tl-none bg-white p-3 text-sm leading-relaxed text-neutral-800 shadow-sm">
            <p className="mb-2">Selamat Siang {displayName},</p>
            <p className="mb-2">
              Saat ini telah saya jadwalkan untuk Zoom Meeting Online dengan tim
              kami, berikut detailnya:
            </p>
            <p className="mb-0 whitespace-pre-line">
              {"👥 "}
              <strong>Peserta:</strong>
              {"\n- "}
              {safeCompany}
              {"\n- "}
              {brand.org}
              {"\n"}
              {"🗓️ "}
              <strong>Tanggal</strong>: {dateLabel || "-"}
              {"\n🕘 "}
              <strong>Pukul</strong>: {startTime || "-"} WIB s/d{" "}
              {endTime || "-"} WIB
            </p>
            <p className="mb-0 mt-2">
              Mohon konfirmasi nya dengan klik tombol di bawah ya {displayName}:
            </p>
          </div>

          {/* Tombol konfirmasi (mock) */}
          <div className="mt-1 space-y-1">
            <button
              type="button"
              className="flex w-full cursor-default items-center justify-center gap-2 rounded-lg bg-white py-2 text-sm font-medium text-[#0a7cff] shadow-sm"
            >
              <ReplyIcon /> Ya, Confirm
            </button>
            <button
              type="button"
              className="flex w-full cursor-default items-center justify-center gap-2 rounded-lg bg-white py-2 text-sm font-medium text-[#0a7cff] shadow-sm"
            >
              <ReplyIcon /> Tidak, Tolong Reschedule
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingWhatsappPreview;
